
{
  const headers = document.querySelectorAll('.accordion_header_item');
  const contents = document.querySelectorAll('.accordion_content_item');

  headers.forEach((header, index) => {
    header.addEventListener('click', () => {
      const isActive = header.classList.contains('active');
      const text = header.querySelector('.accordion_header_text')?.innerText?.trim() || '';

      // Remove all active classes
      headers.forEach(h => h.classList.remove('active'));
      contents.forEach(c => c.classList.remove('active'));

      if (!isActive) {
        header.classList.add('active');
        contents[index].classList.add('active');

        tagular('ElementClicked', {
          actionOutcome: 'EXPAND',
          correlationId: null, 
          outboundUrl: null,
          webElement: {
            elementType: "Tab",
            htmlId: null,
            location: 'PDP',
            name: text,
            position: String(index + 1),
            text: text,
            variant: null,
          }
        });
      } else {
        // Collapsing the currently active tab
        tagular('ElementClicked', {
          actionOutcome: 'COLLAPSE',
          correlationId: null,
          outboundUrl: null,
          webElement: {
            elementType: "Tab",
            htmlId: null,
            location: 'PDP',
            name: text,
            position: String(index + 1),
            text: text,
            variant: null,
          }
        });
      }
    });
  });
}


{
  // PRODUCT-INFORMATION

  const checkbox = document.querySelector(".js-membership-subscription");
  const hiddenInputs = document.querySelectorAll(".js-replace-id");
  const jsSubDivs = document.querySelectorAll(".js-sub-div");
  const defaultDivs = document.querySelectorAll(".default");

  // Store original variant IDs for all inputs
  const originalVariantIds = Array.from(hiddenInputs).map(input => input.value);

  if (checkbox && hiddenInputs.length > 0) {
    checkbox.addEventListener("click", function () {
      setTimeout(() => {
        const insiderTag = document.querySelector(".js-insider-tag");
        const changeText = document.querySelectorAll(".js-discount_label");

        const productId = checkbox.getAttribute("data-js-product-id");

        if (checkbox.checked) {
          let checkedProducts = JSON.parse(sessionStorage.getItem("checkboxCheck") || "[]");
          if (productId && !checkedProducts.includes(productId)) {
            checkedProducts.push(productId);
            sessionStorage.setItem("checkboxCheck", JSON.stringify(checkedProducts));
          }

          const membershipVariantId = checkbox.getAttribute("data-variant-id");

          localStorage.setItem(`membershipSwap_${productId}`, membershipVariantId);

          hiddenInputs.forEach((input) => {
            input.value = membershipVariantId;
          });

          insiderTag?.classList.add("insider-tag");

          defaultDivs.forEach((item) => {
            item.classList.add("hidden");
          });

          jsSubDivs.forEach((item) => {
            item.classList.remove("hidden");
          });

        } else {
          let checkedProducts = JSON.parse(sessionStorage.getItem("checkboxCheck") || "[]");
          const updated = checkedProducts.filter(id => id !== productId);
          sessionStorage.setItem("checkboxCheck", JSON.stringify(updated));

          localStorage.removeItem(`membershipSwap_${productId}`);

          hiddenInputs.forEach((input, index) => {
            input.value = originalVariantIds[index];
          });

          insiderTag?.classList.remove("insider-tag");

          defaultDivs.forEach((item) => {
            item.classList.remove("hidden");
          });

          jsSubDivs.forEach((item) => {
            item.classList.add("hidden");
          });
        }
      }, 300);
    });
  }

  const productId = checkbox?.getAttribute("data-js-product-id");
  const checkedProducts = JSON.parse(sessionStorage.getItem("checkboxCheck") || "[]");

  if (checkbox) {
    const storedVariantId = localStorage.getItem(`membershipSwap_${productId}`);
    if (productId && checkedProducts.includes(productId) && storedVariantId) {
      checkbox.checked = true;

      hiddenInputs.forEach((input) => {
        input.value = storedVariantId;
      });

      checkbox.dispatchEvent(new Event("change"));

      const swatchToggle = document.querySelector(".membership_swatch_main summary");
      swatchToggle?.click();
    } else {
      checkbox.checked = false;
    }
  }
}

  const stickyRemoveBtn = document.querySelector(".js-sticky-remove-button");
  const mainRemoveBtn = document.querySelector(".js-main-remove-button");

  let isSyncing = false;

  function syncClick(fromBtn, toBtn) {
    fromBtn.addEventListener("click", function () {
      if (isSyncing) return;
      isSyncing = true;
      toBtn.click();
      setTimeout(() => {
        isSyncing = false;
      }, 10); // small delay to prevent infinite loop
    });
  }

  if (stickyRemoveBtn && mainRemoveBtn) {
    syncClick(stickyRemoveBtn, mainRemoveBtn);
    syncClick(mainRemoveBtn, stickyRemoveBtn);
  }

  // Shop Pay button Cohesion Event
document.addEventListener("DOMContentLoaded", function () {
  const acceleratedCheckout = document.querySelector("shopify-accelerated-checkout");
  if (!acceleratedCheckout) return;

  const productEl = document.querySelector(".product__info.js-new-ui");
  if (!productEl) return;

  const productData = {
    productId: productEl.dataset.productId?.toString() || null,
    upc: productEl.dataset.productUpc || null,
    sku: productEl.dataset.productSku || null,
    title: productEl.dataset.productTitle || null,
    category: productEl.dataset.productCategory || null,
    format: productEl.dataset.productFormat || null,
    variant: productEl.dataset.productFormat || null,
    price: parseFloat(productEl.dataset.productPrice) || null,
  };

  acceleratedCheckout.addEventListener("click", function () {
    tagular("ProductClicked", {
      actionOutcome: "Checkout",
      correlationId: null,
      viewCorrelationId: null,
      listId: null,
      outboundUrl: null,
      product: {
        brand: "SHOP",
        category: productData.category,
        coupon: null,
        formatSubtype: null,
        formatType: productData.format,
        location: "PDP",
        name: productData.title,
        pageId: null,
        position: null,
        price: productData.price,
        productId: productData.id,
        quantity: 1,
        sku: productData.sku,
        subscription: {
          frequency: null,
        },
        text: "Buy with Shop Pay",
        upc: productData.upc,
        variant: productData.variant,
        positionEngine: null,
      },
    });
  });
});




// Buy Button && apple Cohesion Event
{
document.addEventListener("DOMContentLoaded", function () {
  const buyButtons = document.querySelectorAll(".js-buy-button-another");
  if (!buyButtons.length) return;

  const productEl = document.querySelector(".product__info.js-new-ui");
  if (!productEl) return;

  // Read product data from dataset
  const productData = {
    id: productEl.dataset.productId || null,
    upc: productEl.dataset.productUpc || null,
    sku: productEl.dataset.productSku || null,
    title: productEl.dataset.productTitle || null,
    category: productEl.dataset.productCategory || null,
    format: productEl.dataset.productFormat || null,
    variant: productEl.dataset.productFormat || null, 
    price: productEl.dataset.productPrice || null,
  };

  buyButtons.forEach((item) => {
    item.addEventListener("click", async function (e) {
      getCartItem();

      const isEsimProduct = item.getAttribute("data-esim-product");
      const isEsimProductHref = item.dataset.href;

      if (isEsimProduct === "true") {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              attributes: {
                esim_promotion: 'true'
              }
            })
          });
        } catch (err) {
          console.error("Failed to update esim_promotion attribute:", err);
        }
      }

    
    let buttonText = item.innerText.trim();

    if (buttonText.includes("Pay")) {
      buttonText = buttonText.replace("Pay", "Apple Pay");
    }
    
     tagular("ProductClicked", {
      actionOutcome: "Checkout",
      correlationId: null,
      viewCorrelationId: null,
      listId: null,
      outboundUrl: null,
      product: {
        brand: "SHOP",
        category: productData.category,
        coupon: null,
        formatSubtype: null,
        formatType: productData.format,
        location: "PDP",
        name: productData.title,
        pageId: null,
        position: null,
        price: parseFloat(productData.price), 
        productId: productData.id,
        quantity: 1,
        sku: productData.sku,
        subscription: {
          frequency: null,
        },
        text: buttonText,
        upc: productData.upc,
        variant: productData.variant,
        positionEngine: null,
      },
    });
        setTimeout(() => {  
         window.location.href = isEsimProductHref;
        }, 1000); 

    });
  });
});

function getCartItem() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      const variantData = [];

      cart.items.forEach(item => {
        variantData.push({
          variant_id: item.variant_id,
          quantity: item.quantity
        });
      });

      localStorage.setItem('cartVariantData', JSON.stringify(variantData));
      localStorage.setItem('checkoutCompleted', 'true');
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

async function addToCart() {
  const checkoutCompleted = localStorage.getItem('checkoutCompleted');
  const variantData = JSON.parse(localStorage.getItem('cartVariantData') || '[]');
  const loader = document.querySelector(".loader");

  if (checkoutCompleted === 'true' && variantData.length > 0) {
    console.log('Re-adding items after checkout...');
    if (loader && window.location.pathname.includes("/cart")) {
      loader.style.display = 'block';
    }

    try {
      for (const item of variantData) {
        const { variant_id, quantity } = item;

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variant_id,
            quantity: quantity,
            properties: { "_restored_after_checkout": "true" }
          })
        });

        const data = await res.json();
        console.log(`Variant ${variant_id} (Qty: ${quantity}) added to cart:`, data);
      }

      document.querySelectorAll(".product-item__cta").forEach(domItem => {
        const productId = domItem.dataset.variantId;
        if (productId) {
          const isInCart = variantData.some(cartItem => {
            return String(cartItem.variant_id) === String(productId);
          });

          if (isInCart) {
            const mainwrapper = domItem.closest(".product-item__cta-wrapper");
            domItem.style.display = "none";
            domItem.classList.add("js-product-added");

            const inCartIndicator = mainwrapper?.querySelector(".main-In-cart");
            const inCartWrapper = mainwrapper?.querySelector(".in-cart-wrapper");
            const removeButton = mainwrapper?.querySelector(".main-remove-cart");

            if (inCartIndicator) {
              removeButton.classList.add("custom-add-to-cart");
              removeButton.classList.add("hidden-important");
              inCartIndicator.classList.remove("hidden-important");
              inCartWrapper.classList.remove("hidden-important");
            }
          }
        }
      });

      // Reset the localStorage flag
      localStorage.setItem('checkoutCompleted', 'false');

      // Fetch updated cart data
      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();

      // Dispatch update events
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart: cartData }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: { cart: cartData }
      }));

      // Update cart sections
      const sectionsToUpdate = ['cart-icon-bubble', 'CartDrawer'];
      const sectionsUrl = `/cart?sections=${sectionsToUpdate.join(',')}`;
      const htmlRes = await fetch(sectionsUrl);
      const html = await htmlRes.json();

      sectionsToUpdate.forEach(id => {
        const el = document.getElementById(id);
        if (el && html[id]) {
          el.innerHTML = html[id];
        }
      });
      

      if (window.location.pathname.includes("/cart")) {
        window.location.reload();
      }

    } catch (error) {
      console.error("Error in addToCart:", error);
    }

  } else {
    console.warn('Checkout not completed or no variant data to re-add.');
  }
}

addToCart();


}

// Recommended For You
{
  if (document.querySelector('section.new_product_ui')){
  const viewCount = new Map();
  const clickCount = new Map();
  const viewedProducts = new Set();

  const productObserver = new IntersectionObserver(handleIntersections, {
    threshold: 0.5
  });

  function handleIntersections(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const product = entry.target;
      const productId = product.dataset.product;
      if (!productId || viewedProducts.has(productId)) return;

      viewCount.set(productId, (viewCount.get(productId) || 0) + 1);
      const productMeta = extractProductMetadata(product);
      if (!productMeta) return;

      const isPDP = isPDPElement(product);
      const eventName = isPDP ? 'ProductViewed' : 'ProductViewed';

      tagular(eventName, { product: productMeta });
      viewedProducts.add(productId);
    });
  }

  function extractProductMetadata(product) {
    const titleEl = product.querySelector('.product-item-meta__title');
    const title = titleEl ? titleEl.textContent.trim() : null;


    const variant = product.querySelector('.product-item-meta__type').innerText.trim() || null;

    const priceEle = product.querySelector('.price');
    const priceMatch = priceEle?.textContent?.match(/[\d,]+\.\d{2}/);
    const price = priceMatch ? priceMatch[0] : "0.00";
    const productPrice = parseFloat(price.replace(/,/g, "")) || null;

    const tabName = getActiveTabName(product);
    const position = parseInt(product.getAttribute('data-product-index')) || null;

    let sku = product.getAttribute('data-sku');
    let upc = product.getAttribute('data-code');

    if ((!sku || !upc) && product.querySelector('script[tagular-data]')) {
      try {
        const tagularJson = product.querySelector('script[tagular-data]');
        const data = JSON.parse(tagularJson.textContent);
        const variantId = variantEl?.getAttribute('value');
        if (data?.[variantId]) {
          sku = data[variantId].sku || null;
          upc = data[variantId].barcode || null;
        } else {
          const first = Object.keys(data)[0];
          sku = data[first].sku || null;
          upc = data[first].barcode || null;
        }
      } catch (e) {
        // Ignore JSON error
      }
    }

    let productLocation = null;
    const productPageElement = isPDPElement(product);

    if (productPageElement) {
      productLocation = 'PDP - Recommended For You';
    }

    if (!productLocation) return null;

    return {
      brand: 'SHOP',
      category: tabName,
      coupon: null,
      formatSubtype: null,
      formatType: variant,
      location: productLocation,
      name: title,
      pageId: null,
      position: position,
      price: productPrice,
      productId: null,
      quantity: 1,
      sku: sku,
      subscription: { frequency: null },
      text: null,
      upc: upc,
      variant: variant,
      positionEngine: null
    };
  }

  function getActiveTabName(product) {
    const tabContainer = product.closest('.container');
    const tab = tabContainer?.querySelector('.tabs-nav__item[aria-expanded="true"]');
    return tab ? tab.textContent.trim() : null;
  }

  function isPDPElement(el) {
    return el.closest('.js-event-product-page') || el.classList.contains('js-event-product-page');
  }

  function trackProductElement(product) {
    const productId = product.dataset.product;
    if (!productId) return;

    if (!viewedProducts.has(productId)) {
      productObserver.observe(product);
    }

    const links = product.querySelectorAll('a[href]');
    links.forEach(link => {
      if (link.dataset.tracked) return;
      link.dataset.tracked = "true";

      link.addEventListener('click', () => {
        clickCount.set(productId, (clickCount.get(productId) || 0) + 1);

        const productMeta = extractProductMetadata(product);
        if (productMeta) {
          const isPDP = isPDPElement(product);
          const eventName = isPDP ? 'ProductClicked' : 'ProductClicked';
          tagular(eventName, { product: productMeta });
        }
      });
    });
  }

  function setupProductTracking() {
    const productTiles = document.querySelectorAll('.product-item');
    const mainProductPage = document.querySelector('.js-event-product-page');

    productTiles.forEach(product => {
      trackProductElement(product);
    });

    if (mainProductPage) {
      trackProductElement(mainProductPage);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupProductTracking();
  });

  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if ([...mutation.addedNodes].some(node =>
        node.nodeType === 1 && node.matches?.('.product-item, .product-item *'))) {
        setupProductTracking();
        break;
      }
    }
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}
}

{
const target = document.querySelector(".pdp_small_banner");

if (target) {
  // Create the Intersection Observer
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        // Check if the element is fully visible (100% in view)
        if (entry.isIntersecting && entry.intersectionRatio === 1) {

          tagular("ElementViewed", {
            webElement: {
              elementType: "Module",
              htmlId:  null,
              location: "Gift Guide",
              name: "Gift Guide",
              position: null,
              text: null,
              variant: null
            }
          });

          // Stop observing after it fires once
          obs.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 1.0 // 100% visibility required
    }
  );
  observer.observe(target);
}

if (target) {
  const button = target.querySelector(".pdp_small_banner_button a");

  if (button) {
    button.addEventListener("click", () => {
      tagular("ElementClicked", {
        actionOutcome: "INTERNALLINK",
        outboundUrl: button.getAttribute("href") || null,
        webElement: {
          elementType: "Button",
          htmlId: null,
          location: "Gift Guide",
          name: "Gift Guide",
          position: null,
          text: button.textContent.trim() || null,
          variant: null
        }
      });
    });
  } 
}
}